<template>

  <!--Merchant View {{ $route.params.id}} <br/>-->
  <!--  Returned Id: {{articleId}} {{merchantData.siteUrl}}-->
  <div v-if="loading" class="loading">
    <br /><br /><br /><br /><br />
    <pulse-loader color="#000000" size="10px"></pulse-loader>
  </div>
  <div v-else class="container mt-3">
    <div class="row text-center">
      <div class="col-12">
        <span class="merchNameTitle">{{ selectedMercdata.merchantName }}</span><Br />

        <!-- <p>{{this.selectedMercdata}}</p> -->

        <div class="mt-2">
          <span class="tagger" v-for="tag in selectedMercdata.tags" :key="tag.id" style="margin-right:5px ">{{
            tag.tag_name
          }}</span>
        </div>
      </div>
      <!--      <div class="col">-->
      <!--        <a :href="merchantData.siteUrl">-->
      <!--          <div class="" style="border: 1px solid black;">-->
      <!--            <img src="@/assets/images/url-icon.png" height="10"/><br/>-->
      <!--            VISIT-->
      <!--          </div>-->
      <!--        </a>-->
      <!--      </div>-->
    </div>
    <hr />

    <div class="container mt-4" v-if="shopAtText">
      <!--      You can buy now pay later in 3 interest free instalments with Koko at {{ merchantData.merchantName }}.-->
      Shop at {{ selectedMercdata.merchantName }} and pay in 3 interest free
      instalments, even with your debit card!
    </div>
    <div class="container mt-4" v-if="holidayAtText">
      <!--      You can buy now pay later in 3 interest free instalments with Koko at {{ merchantData.merchantName }}.-->
      Holiday at {{ selectedMercdata.merchantName }} and pay in 3 interest free
      instalments, even with your debit card!
    </div>

    <div class="container mt-4" v-if="bookAtText">
      <!--      You can buy now pay later in 3 interest free instalments with Koko at {{ merchantData.merchantName }}.-->
      Book at {{ selectedMercdata.merchantName }} and pay in 3 interest free
      instalments, even with your debit card!
    </div>


    <!--    <div class="container">-->
    <!--      <div class="row mt-3" v-if="merchantData.doesOffline === true && merchantData.doesOnline==true">-->
    <!--        You can buy now pay later in 3 interest free instalments with Koko at {{ merchantData.merchantName }} at both-->
    <!--        their online and retail outlets now.-->
    <!--      </div>-->
    <!--      <div class="row mt-3" v-if="merchantData.doesOffline === true && merchantData.doesOnline == false">-->
    <!--        You can buy now pay later in 3 interest free instalments with Koko at {{ merchantData.merchantName }} at retail-->
    <!--        outlets now.-->
    <!--      </div>-->
    <!--      <div class="row mt-3" v-if="merchantData.doesOffline === false && merchantData.doesOnline==true">-->
    <!--        You can buy now pay later in 3 interest free instalments with Koko at {{ merchantData.merchantName }} in their-->
    <!--        website now.-->
    <!--      </div>-->
    <!--    </div>-->

    <div class="container mt-4">
      <a :href="selectedMercdata.siteUrl" class="">
        <div class="row mb-2 align-items-center h-100" v-if="selectedMercdata.doesOnline === true"
          style="background: #ffffff;">
          <div class="col-9"
            style="border: 0px solid; margin-left: 0px; padding-top: 10px; padding-right: 10px; padding-bottom: 10px;">
            <div style="text-align: left;">
              <b>Shop online</b> <Br />
              <div style="font-size: 13px; line-height: normal;">
                Choose Koko as your payment method at the checkout page.
              </div>
            </div>
          </div>
          <div class="col-3 h-100" style=" text-align:right;border: 0px solid;">
            <div class="text-center" style="background: #021FA3">
              <!--          <img src="@/assets/images/url-icon.png" height="15"/><br/>-->
              <div style="font-size: 12px; font-weight: bolder; padding-top:5px; padding-bottom: 5px; color: #ffffff">
                SHOP
              </div>
            </div>
          </div>
        </div>
      </a>
      <a :href="selectedMercdata.socialUrl" class="">
        <div class="row mb-2 align-items-center h-100" v-if="selectedMercdata.doesSocial === true"
          style="background: #ffffff;">
          <div class="col-9" style="border: 0px solid; margin-left: 0px; padding: 10px;">
            <div style="text-align: left;">
              <b>Shop via social media</b> <Br />
              <div style="font-size: 14px; line-height: normal;">
                Message the merchant & receive text message verification to pay
                with Koko.
              </div>
            </div>
          </div>

          <div class="col-3 h-100" style=" text-align:right;border: 0px solid;">
            <div class="text-center" style="background: #021FA3">
              <!--          <img src="@/assets/images/url-icon.png" height="15"/><br/>-->
              <div style="font-size: 12px; font-weight: bolder; padding-top:5px; padding-bottom: 5px; color: #ffffff">
                SHOP
              </div>
            </div>
          </div>
          <!--        <hr/>-->
        </div>
      </a>

      
      <div class="row mb-2 align-items-center h-100" style="background: #ffffff;"
        v-if="selectedMercdata.doesOffline === true" data-toggle="collapse" href="#collapseExample4" role="button"
        aria-expanded="false" aria-controls="collapseExample4">
        <div class="col-9" style="border: 0px solid; margin-left: 0px; padding: 10px;">
          <div style="text-align: left;">
            <b>Shop in-store</b> <Br />
            <div style="font-size: 14px; line-height: normal;">
              Scan the QR code at the store counter.
            </div>
          </div>
        </div>

        

        <div class="col-3 h-100" style=" text-align:right;border: 0px solid;">
          <div class="text-center" style="">
            <div style="font-size: 12px; font-weight: bolder; padding-top:5px; padding-bottom: 5px; color: #000000" data-bs-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
              +VIEW
           </div>
          </div>
        </div>
      </div>


<div class="collapse" id="collapseExample">
  <div class="card card-body">
    <div >
          <div class="row">
            <div class="row">
              <div class="col" style="text-align: left">
                <span class="smallHeading">LOCATIONS</span>
              </div>
            </div>
            <div class="row mt-1" v-for="location in selectedMercdata.offlineLocations" :key="location.id">
              <div class="col-9">
                <div style="text-align: left; font-size: 13px;">
                  <b>{{ location.outletName }}</b> <Br />
                  {{ location.addressLine1 }}
                </div>
              </div>

              <div class="col-3 px-0" style="float: right; border: 0px solid;">
                <a :href="location.mapLink">
                  <img src="@/assets/images/location-arrow.png" style="float: right;" />
                </a>
              </div>

              <div class="mt-1 px-0">              
              </div>
            </div>
          </div>
        </div>
   </div>
</div>

      <hr />
      <div class="row mb-2 align-items-center h-100" style="background: #ffffff;" v-if="selectedMercdata.Phone"
        data-toggle="collapse" href="#collapseExample9" role="button" aria-expanded="false"
        aria-controls="collapseExample9">
        <div class="col-9" style="border: 0px solid; margin-left: 0px; padding: 10px;">
          <div style="text-align: left;">
            <b> Please Contact the merchant.</b> <Br />
          </div>
        </div>

        <div class="col-3 h-100" style=" text-align:right;border: 0px solid;">
          <div class="text-center" style="">
            <div style="font-size: 12px; font-weight: bolder; padding-top:5px; padding-bottom: 5px; color: #000000">
              +VIEW
            </div>
          </div>
        </div>

        <div v-if="selectedMercdata.Phone" class="collapse" id="collapseExample9">
          <div class="row">
            <div class="row">
           
              <div class="col-9"
                style="border: 0px solid; margin-left: 0px; padding-top: 10px; padding-right: 10px; padding-bottom: 10px;">
                <div style="text-align: left;">
                  <input v-on:focus="$event.target.select()" ref="clone" readonly :value="selectedMercdata.Phone"
                    style="border:none;" />
                  <div style="font-size: 13px; line-height: normal;">
                    {{ selectedMercdata.merchantName }}
                  </div>
                </div>
              </div>
              <div class="col-3" style=" text-align:right;border: 0px solid;">
                <div class="text-center" style="background: #021FA3">
                  <div
                    style="font-size: 12px; font-weight: bolder; padding-top:5px; padding-bottom: 5px; color: #ffffff;margin-top: 10px;"
                    @click="copy">
                    COPY
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--        <hr/>-->
      </div>
      <!-- Special Note Section -->

      <div class="row mb-2 align-items-center h-100" style="background: #ffffff;" v-if="selectedMercdata.Note"
        data-toggle="collapse" href="#collapseExample5" role="button" aria-expanded="false"
        aria-controls="collapseExample5">
        <div class="col-9" style="border: 0px solid; margin-left: 0px; padding: 10px;">
          <div style="text-align: left;">
            <b>Merchant Information</b> <Br />
          </div>
        </div>

        <div class="col-3 h-100" style=" text-align:right;border: 0px solid;">
          <div class="text-center" style="">
            <!--          <img src="@/assets/images/url-icon.png" height="15"/><br/>-->
            <div style="font-size: 12px; font-weight: bolder; padding-top:5px; padding-bottom: 5px; color: #000000">
              +VIEW
            </div>
          </div>
        </div>

        <div v-if="selectedMercdata.Note" class="collapse" id="collapseExample5">
          <div class="row">
            <div class="row">
              <div class="col" style="text-align: left">
                <div style="font-size: 14px; line-height: normal;">
                  <p v-html="selectedMercdata.Note"></p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--        <hr/>-->
      </div>
    </div>
  </div>
</template>

<script>
// import axios from "axios";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import Strapi from "../services/strapi-services.js";
const strapi = new Strapi();

export default {
  name: "MerchantDetails",
  components: {
    PulseLoader,
  },
  data() {
    return {
      merchantData: {
        offlineLocations: Array,
        siteUrl: String,
        doesOnline: Boolean,
        merchantName: String,
      },
      loading: true,
      items: [{ message: "Foo" }, { message: "Bar" }],
      selectedMercdata: [],
      shopAtText:null,
      holidayAtText:null,
      bookAtText:null,
    };
  },
  created() {
    this.GetTheMercById();
    // Simple POST request with a JSON body using axios
    // const article = { "MerchantId": 1 };
    // axios
    //   .post(
    //     "https://devapi.paykoko.com/backend/merchant",
    //     '{ "MerchantId": ' + this.$route.params.id + "}"
    //   )
    //   .then((response) => {
    //     this.merchantData = response.data;
    //     this.loading = false;
    //     document.title = this.merchantData.merchantName + " - Merchant";
    //   });
  },

  methods: {
    copy() {
      this.$refs.clone.focus();
      document.execCommand("copy");
    },
    GetTheMercById() {
      let param = this.$route.params.id;

      strapi
        .GetTheSelectedMercById(param)
        .then((res) => {
          this.selectedMercdata = res.data;
          this.tags = this.selectedMercdata.tags;
          if(this.tags.some(tag => tag.tag_name === "tickets")){
              this.shopAtText = false;
              this.holidayAtText = false;
              this.bookAtText = true;
          }
          else if(this.tags.some(tag => tag.tag_name === "travel")){
              this.shopAtText = false;
              this.holidayAtText = true;
              this.bookAtText = false;
          }else{
            this.shopAtText = true;
            this.holidayAtText = false;
            this.bookAtText = false;
          }
          console.log("Selected Merchant data :", this.selectedMercdata);
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.merchNameTitle {
  font-size: 24px;
  font-family: Raleway, sans-serif;
  font-weight: 700;
}

.smallHeading {
  font-family: Raleway;
  font-style: normal;
  font-weight: bold;
  font-size: 10px;
  line-height: 99.9%;
  /* identical to box height, or 10px */

  color: #4d0445;
}

.tagger {
  border-radius: 5px;
  border: 1px solid #1a1b38;
  opacity: 0.5;
  padding: 5px;
  font-size: 12px;
}

a {
  color: #2c3e50;
  text-decoration: none;
}

/* customizable snowflake styling */
.snowflake {
  color: #ffffff;
  font-size: 1.2em;
  font-family: Arial;
  text-shadow: 0 0 1px rgb(206, 206, 206);
}

@-webkit-keyframes snowflakes-fall {
  0% {
    top: -10%;
  }

  100% {
    top: 100%;
  }
}

@-webkit-keyframes snowflakes-shake {
  0% {
    -webkit-transform: translateX(0px);
    transform: translateX(0px);
  }

  50% {
    -webkit-transform: translateX(80px);
    transform: translateX(80px);
  }

  100% {
    -webkit-transform: translateX(0px);
    transform: translateX(0px);
  }
}

@keyframes snowflakes-fall {
  0% {
    top: -10%;
  }

  100% {
    top: 100%;
  }
}

@keyframes snowflakes-shake {
  0% {
    transform: translateX(0px);
  }

  50% {
    transform: translateX(80px);
  }

  100% {
    transform: translateX(0px);
  }
}

</style>
